import { ConfigProvider } from 'antd';
import Main from './Main';
import { playColors } from './constants';
import './App.css';

export const PlayPage = () => (
  <ConfigProvider
    theme={{
      token: {
        fontFamily: 'soehne-breit',
        colorPrimary: playColors.black,
        colorBgContainer: playColors.white,
      },
    }}
  >
    <Main />
  </ConfigProvider>
);
